
import VueCookies from 'vue-cookies';

//로그인
export async function lfnLogin(sUid,sPwd,sSysGbn,sSysSaveYn,sUidSaveYn){

    try{
        let sSysGbnid = "";

        if ((sSysGbn || "") !="")
        {
            sSysGbnid = sSysGbn.id;
        }
        else
        {
            sSysGbnid = sSysGbn;
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uid: sUid, pwd: sPwd, sys_gbn: sSysGbnid})
        }

        const chek_login = await fetch('/Logon/CheckLogin', requestOptions)
        .then(async response => {
            const response_data = await response.json();
            if (!response.ok) {
                // get error message from body or default to response status
                const error = (response_data && response_data.message) || response.status;
                    return Promise.reject(error);
            }
            if (response_data.err == 0) {
                if (response_data.result == "S") {
                    if (sSysSaveYn == true)
                    {
                        VueCookies.set('sysSaveYn', 'Y', '100d'); // 100day
                        VueCookies.set('sysGbn', sSysGbn.id, '100d' ); // 100day
                    }
                    else
                    {
                        VueCookies.set('sysSaveYn', 'N', '100d'); // 100day
                    }

                    if (sUidSaveYn == true) {
                        VueCookies.set('uidSaveYn', 'Y', '100d'); // 100day
                        VueCookies.set('userId', sUid, '100d' ); // 100day
                    }
                    else
                    {
                       VueCookies.set('uidSaveYn', 'N', '100d'); // 100day
                    }

                    var __data = response_data.data.filter(function (e) { return e.col_1 == sSysGbnid; });
                    if (__data.length > 0) {
                        let sUrl = __data[0].col_2; /*실제 로그인 하는 uRL redirect를 시킨다. 편하게*/
                        let __guid = response_data.guid || "";
                        document.getElementById("guid").value = __guid;
                        document.getElementById("frmLogin1").setAttribute("action", sUrl);
                        document.getElementById("frmLogin1").submit();
                    } /*if (__data.length > 0)*/
                }
                else {
                    alert(response_data.resultMsg);
                }
            } else {
                    if ((response_data.result || "") == "F_ChagePwd") {
                        alert(" Your login password has expired after 90 days. Please update your password.");
                        window.location.href = "/Home/ChangePassword?eid=" + (response_data.guid||""); /*비밀번호가 만료되어 더이상 사용할 수 없다.*/
                        return;
                    }
                    else if ((response_data.result || "") == "F_INITPWD") {
                        alert(" Please reset your login password.");
                        window.location.href = "/Home/SetPassword?eid=" + (response_data.guid || ""); /*비밀번호가 만료되어 더이상 사용할 수 없다.*/
                        return;
                    }
                    else if ((response_data.result || "") == "F_BK") {
                        alert(" Your account has been locked due to incorrect password entries. \n Please unlock the account. ");
                        window.location.href = "/Home/ClearBlock"; /*계정이 블럭처리됨.*/
                        return;
                    }
                    // CMSH-996 TOTP 도입 — 신규 분기
                    else if ((response_data.result || "") == "F_TOTP_ENROLL" || (response_data.result || "") == "F_TOTP_ENROLL_OPTIONAL") {
                        let _token = response_data.pending_token || "";
                        let _optional = (response_data.result == "F_TOTP_ENROLL_OPTIONAL") ? "&optional=1" : "";
                        window.location.href = "/Home/TotpEnroll?token=" + encodeURIComponent(_token) + "&sys_gbn=" + encodeURIComponent(sSysGbnid) + _optional;
                        return;
                    }
                    else if ((response_data.result || "") == "F_TOTP_VERIFY") {
                        let _token = response_data.pending_token || "";
                        window.location.href = "/Home/TotpVerify?token=" + encodeURIComponent(_token) + "&sys_gbn=" + encodeURIComponent(sSysGbnid);
                        return;
                    }
                    else {
                        alert(response_data.errMsg);
                    }
            }
            return chek_login;
      })
      .catch(function (err) {
        return err;
      });
    }catch(err){
        return err;
    }
}

//소원수리함 저장
export async function lfnComplaintSave(formData){
    try{
        const requestOptions = {
            method: 'POST',
            body: formData
        }

        const response = await fetch('/Logon/ComplaintAdd', requestOptions);
        const response_data = await response.json();
        return response_data

    }catch(err){
        return err;
    }
}
